import React from 'react';
import { Icon } from '@iconify/react';
import config from '../../config';

const CategoryTable = ({ categories, loading, onEdit, onDelete, onSort, sortConfig }) => {
    
    const getIconUrl = (iconPath) => {
        if (!iconPath) return null;
        if (iconPath.startsWith('http')) return iconPath;
        return `${config.API_BASE_URL}${iconPath}`;
    };

    if (loading) {
        return <div className="text-center py-5">Loading categories...</div>;
    }

    if (!categories || categories.length === 0) {
        return <div className="text-center py-5 text-secondary-light">No categories found.</div>;
    }

    const renderSortIcon = (key) => {
        if (sortConfig.key !== key) return <Icon icon="akar-icons:arrow-up-down" className="ms-1 text-xs" />;
        return sortConfig.direction === 'asc' 
            ? <Icon icon="akar-icons:arrow-up" className="ms-1 text-xs text-primary-600" />
            : <Icon icon="akar-icons:arrow-down" className="ms-1 text-xs text-primary-600" />;
    };

    return (
        <div className="table-responsive scroll-sm">
            <table className="table bordered-table mb-0">
                <thead>
                    <tr>
                        <th scope="col">Icon</th>
                        <th scope="col" onClick={() => onSort('name')} className="cursor-pointer">
                            Name {renderSortIcon('name')}
                        </th>
                        <th scope="col" onClick={() => onSort('slug')} className="cursor-pointer">
                            Slug {renderSortIcon('slug')}
                        </th>
                        <th scope="col" onClick={() => onSort('is_default')} className="cursor-pointer">
                            Status {renderSortIcon('is_default')}
                        </th>
                        <th scope="col" onClick={() => onSort('created_at')} className="cursor-pointer">
                            Created At {renderSortIcon('created_at')}
                        </th>
                        <th scope="col" className="text-center">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {categories.map((item) => (
                        <tr key={item.id}>
                            <td>
                                <div className="d-flex align-items-center">
                                    {item.icon ? (
                                        <img 
                                            src={getIconUrl(item.icon)} 
                                            alt={item.name} 
                                            className="w-48-px h-48-px rounded-circle object-fit-cover border border-neutral-200"
                                            onError={(e) => { e.target.onerror = null; e.target.src = 'https://via.placeholder.com/48?text=Icon'; }} 
                                        />
                                    ) : (
                                        <div className="w-48-px h-48-px rounded-circle bg-primary-50 d-flex align-items-center justify-content-center text-primary-600 border border-neutral-200">
                                            <span className="text-xl fw-bold">{item.name.charAt(0).toUpperCase()}</span>
                                        </div>
                                    )}
                                </div>
                            </td>
                            <td>
                                <span className="text-md fw-medium text-primary-light">{item.name}</span>
                                {item.description && <div className="text-xs text-secondary-light mt-1">{item.description}</div>}
                            </td>
                            <td><span className="text-sm">{item.slug}</span></td>
                            <td>
                                {item.is_default ? (
                                    <span className="bg-success-focus text-success-main px-24 py-4 rounded-pill fw-medium text-sm">Default</span>
                                ) : (
                                    <span className="bg-info-focus text-info-main px-24 py-4 rounded-pill fw-medium text-sm">Custom</span>
                                )}
                            </td>
                            <td><span className="text-sm">{new Date(item.created_at).toLocaleDateString()}</span></td>
                            <td className="text-center">
                                <div className="d-flex align-items-center justify-content-center gap-2">
                                    <button 
                                        type="button" 
                                        onClick={() => onEdit(item)}
                                        className="w-32-px h-32-px bg-primary-light text-primary-600 rounded-circle d-inline-flex align-items-center justify-content-center"
                                    >
                                        <Icon icon="iconamoon:edit-light" />
                                    </button>
                                    <button 
                                        type="button" 
                                        onClick={() => onDelete(item.id, item.is_default)}
                                        className="w-32-px h-32-px bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                                    >
                                        <Icon icon="mingcute:delete-2-line" />
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default CategoryTable;
